import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onesevanseaterurbania() {

const cardData = {
keyword: "17 Seater Urbania on Rent in Pune",
headingDescription: "17 Seater Urbania on Rent in Pune is a convenient group transportation option for corporate travel, family trips, employee movement, events, airport transfers, and outstation journeys. Ruturaj Enterprises provides spacious Urbania vehicles with comfortable seating, air conditioning, professional driver assistance, and suitable arrangements for planned group travel. Whether the requirement is for a local Pune journey, business program, family tour, or longer intercity trip, a 17-seater Urbania helps passengers travel together in a comfortable and organized manner.",
topPlaces: [
{
title: "Hadapsar",
description: "Hadapsar is a major residential, commercial, and corporate area in Pune with strong connectivity to Magarpatta, Kharadi, and other business districts. A 17-seater Urbania can be arranged from Hadapsar for employee transportation, family trips, corporate events, airport transfers, and group journeys."
},
{
title: "Kharadi EON IT Park",
description: "Kharadi EON IT Park is an important business destination where larger group vehicles are useful for employee travel, corporate meetings, company events, and team transportation. A 17-seater Urbania allows corporate groups to travel together comfortably instead of coordinating several smaller vehicles."
},
{
title: "Viman Nagar",
description: "Viman Nagar is located close to Pune Airport and several hotels, offices, restaurants, and commercial establishments. A 17-seater Urbania can support group airport transfers, corporate travel, family transportation, event movement, and journeys connecting Viman Nagar with other Pune destinations."
},
{
title: "Pune International Airport",
description: "Pune International Airport is a practical pickup and drop point for families, corporate groups, and visitors travelling with luggage. A 17-seater Urbania provides sufficient passenger space for coordinated airport transfers and can take larger groups directly to hotels, offices, homes, or event venues."
},
{
title: "Swargate",
description: "Swargate is a central transportation hub with convenient access to several parts of Pune. A 17-seater Urbania from Swargate can be useful for group tours, family travel, wedding functions, corporate programs, pilgrimage trips, and outstation journeys requiring a larger vehicle."
},
{
title: "Camp Pune",
description: "Camp Pune is a well-established central area surrounded by commercial establishments, hotels, shopping destinations, and important city routes. Urbania hire from Camp can be arranged for group transportation, family functions, business travel, airport transfers, and organized local or outstation trips."
},
{
title: "Bibwewadi",
description: "Bibwewadi offers connectivity toward Kondhwa, Dhankawadi, Swargate, and southern Pune. A 17-seater Urbania is suitable for families, corporate teams, event groups, and tour parties requiring comfortable transportation from this part of the city to local or outstation destinations."
},
{
title: "Dhankawadi",
description: "Dhankawadi is a residential and educational area with convenient connections toward Katraj and central Pune. Groups can use a 17-seater Urbania here for family trips, college or organizational events, pilgrimage journeys, weddings, sightseeing programs, and longer outstation travel."
},
{
title: "Kothrud",
description: "Kothrud is a major residential and commercial locality with access to western Pune and routes toward several popular travel destinations. A 17-seater Urbania can provide comfortable group transportation for family holidays, corporate outings, events, airport transfers, and intercity journeys."
},
{
title: "Karve Nagar",
description: "Karve Nagar is a well-connected residential area near Kothrud and central Pune. A 17-seater Urbania can be arranged from this location for group travel, family functions, corporate programs, educational trips, weddings, and outstation journeys where passengers prefer to travel together."
}
],
services: [
{
name: "17 Seater Urbania Traveller Pune",
description: "17 Seater Urbania Traveller Pune is a practical choice for groups that need spacious and comfortable transportation within Pune or for longer journeys. It can be arranged for family trips, corporate travel, events, sightseeing, airport transfers, and organized group programs."
},
{
name: "17 Seater Urbania Hire in Pune",
description: "17 Seater Urbania Hire in Pune provides a convenient vehicle option for larger groups travelling together. With spacious seating, air conditioning, and professional driver support, it is suitable for corporate events, family functions, tours, weddings, and outstation travel."
},
{
name: "17 Seater Urbania Booking Pune",
description: "17 Seater Urbania Booking Pune helps groups plan their transportation in advance for specific travel dates, pickup points, and destinations. Advance booking can be useful for corporate programs, family tours, weddings, events, airport transfers, and holiday travel."
},
{
name: "17 Seater Urbania Van Rental Pune",
description: "17 Seater Urbania Van Rental Pune is suitable for customers looking for a spacious vehicle for group transportation. The vehicle can be used for local travel, sightseeing, corporate movement, family functions, educational trips, and outstation journeys from Pune."
},
{
name: "17 Seater Luxury Urbania on Rent Pune",
description: "17 Seater Luxury Urbania on Rent Pune offers a premium group travel option for customers who value spacious seating and a comfortable travel environment. It is suitable for executive groups, corporate events, family celebrations, weddings, tours, and longer journeys."
},
{
name: "Urbania 17 Seater on Rent Near Me Pune",
description: "Urbania 17 Seater on Rent Near Me Pune is useful for customers searching for a larger group vehicle close to their preferred pickup location. It can be arranged for local Pune travel, family trips, corporate transportation, events, airport transfers, and outstation requirements."
},
{
name: "17 Seater Urbania for Outstation Pune",
description: "17 Seater Urbania for Outstation Pune is designed for groups travelling from Pune to other cities and tourist destinations. The spacious vehicle is suitable for family holidays, corporate outings, weddings, pilgrimage trips, group tours, and long-distance journeys with professional driver assistance."
},
{
name: "17 Seater Urbania for Family Trip Pune",
description: "17 Seater Urbania for Family Trip Pune provides a comfortable option when a larger family or extended group wants to travel together. It can be used for holidays, weddings, religious trips, sightseeing, family functions, and multi-day journeys from Pune."
},
{
name: "17 Seater Urbania for Group Travel Pune",
description: "17 Seater Urbania for Group Travel Pune is suitable for friends, families, corporate teams, event participants, and tour groups. Travelling together in one spacious vehicle simplifies coordination while providing a convenient solution for both local and outstation journeys."
},
{
name: "17 Seater Urbania on Rent Hadapsar",
description: "17 Seater Urbania on Rent Hadapsar is suitable for groups starting their journey from Hadapsar and nearby areas. It can be arranged for corporate travel, family trips, weddings, events, airport transfers, sightseeing, and outstation journeys requiring larger passenger capacity."
},
{
name: "17 Seater Urbania Hire in Hadapsar",
description: "17 Seater Urbania Hire in Hadapsar provides group transportation for employees, families, tourists, and event participants. A dedicated Urbania with a professional driver can make travel from Hadapsar to Pune destinations or outstation locations more organized and comfortable."
},
{
name: "17 Seater Urbania on Rent Kharadi",
description: "17 Seater Urbania on Rent Kharadi is a convenient choice for corporate groups and residents travelling together from Kharadi. It can support office events, employee travel, airport transfers, family functions, group tours, and intercity journeys."
},
{
name: "17 Seater Urbania EON IT Park",
description: "17 Seater Urbania EON IT Park is useful for employee transportation, corporate meetings, business events, team outings, and group movement around Kharadi. A larger vehicle can help companies coordinate travel for teams and business visitors more efficiently."
},
{
name: "17 Seater Urbania on Rent Viman Nagar",
description: "17 Seater Urbania on Rent Viman Nagar can be arranged for families, corporate groups, tourists, and event participants starting from Viman Nagar. Its larger seating capacity makes it suitable for airport transfers, hotel movement, business travel, and outstation trips."
},
{
name: "17 Seater Urbania near Pune Airport",
description: "17 Seater Urbania near Pune Airport is suitable for groups arriving or departing through Pune International Airport. It provides a convenient way for multiple passengers to travel together with luggage between the airport, hotels, offices, residences, and event venues."
},
{
name: "17 Seater Urbania on Rent Swargate",
description: "17 Seater Urbania on Rent Swargate is useful for groups beginning their journey from this central Pune transport hub. The vehicle can be arranged for tours, family functions, corporate travel, pilgrimage trips, airport transfers, and outstation destinations."
},
{
name: "17 Seater Urbania Camp Pune",
description: "17 Seater Urbania Camp Pune provides a spacious group transportation option for customers travelling from Pune Camp and surrounding areas. It can be used for corporate programs, family trips, weddings, sightseeing, airport transfers, and intercity journeys."
},
{
name: "17 Seater Urbania on Rent Bibwewadi",
description: "17 Seater Urbania on Rent Bibwewadi is suitable for larger groups looking for a comfortable vehicle from southern Pune. It can support family travel, corporate outings, weddings, religious journeys, sightseeing programs, and outstation trips."
},
{
name: "17 Seater Urbania near Dhankawadi",
description: "17 Seater Urbania near Dhankawadi is a useful option for groups starting from Dhankawadi and nearby southern Pune areas. It can be arranged for family holidays, events, corporate transportation, educational trips, pilgrimage travel, and longer group journeys."
},
{
name: "17 Seater Urbania on Rent Kothrud",
description: "17 Seater Urbania on Rent Kothrud offers a convenient larger vehicle for families, corporate teams, tourists, and event groups. It is suitable for local transportation, western Pune travel, airport transfers, sightseeing, and outstation journeys."
},
{
name: "17 Seater Urbania Karve Nagar",
description: "17 Seater Urbania Karve Nagar provides group transportation for residents, families, companies, and organized travel groups. The vehicle can be used for weddings, corporate events, holiday trips, pilgrimage journeys, airport transfers, and intercity travel."
}
],
tableData: [
["17 Seater Urbania Traveller Pune"],
["17 Seater Urbania Hire in Pune"],
["17 Seater Urbania Booking Pune"],
["17 Seater Urbania Van Rental Pune"],
["17 Seater Luxury Urbania on Rent Pune"],
["Urbania 17 Seater on Rent Near Me Pune"],
["17 Seater Urbania for Outstation Pune"],
["17 Seater Urbania for Family Trip Pune"],
["17 Seater Urbania for Group Travel Pune"],
["17 Seater Urbania on Rent Hadapsar"],
["17 Seater Urbania Hire in Hadapsar"],
["17 Seater Urbania on Rent Kharadi"],
["17 Seater Urbania EON IT Park"],
["17 Seater Urbania on Rent Viman Nagar"],
["17 Seater Urbania near Pune Airport"],
["17 Seater Urbania on Rent Swargate"],
["17 Seater Urbania Camp Pune"],
["17 Seater Urbania on Rent Bibwewadi"],
["17 Seater Urbania near Dhankawadi"],
["17 Seater Urbania on Rent Kothrud"],
["17 Seater Urbania Karve Nagar"]
],
whychoose: [
{
WhyChooseheading: "Spacious 17-Seater Group Transportation",
WhyChoosedescription: "A 17-seater Urbania provides enough passenger capacity for larger families, corporate teams, event groups, and tour parties travelling together. Using one spacious vehicle can simplify coordination and make the overall journey more convenient."
},
{
WhyChooseheading: "Comfortable Seating for Longer Journeys",
WhyChoosedescription: "Long-distance group travel requires a vehicle that gives passengers adequate space throughout the journey. The Urbania format offers a comfortable environment for outstation holidays, corporate programs, family tours, pilgrimage trips, and multi-day travel."
},
{
WhyChooseheading: "Useful for Corporate and Event Travel",
WhyChoosedescription: "Companies can use the 17-seater Urbania for conferences, seminars, employee outings, business meetings, annual functions, and team events. The larger capacity makes it easier to transport employees and guests according to a planned event schedule."
},
{
WhyChooseheading: "Suitable for Family and Group Trips",
WhyChoosedescription: "Families and groups often prefer travelling together rather than splitting passengers between several cars. A 17-seater Urbania provides a practical option for holidays, weddings, family functions, sightseeing programs, and religious journeys."
},
{
WhyChooseheading: "Professional Driver Support",
WhyChoosedescription: "Having a dedicated professional driver allows passengers to focus on their group activities and travel plans instead of managing the vehicle themselves. Driver support is particularly helpful for unfamiliar destinations and longer intercity journeys."
},
{
WhyChooseheading: "Airport and City Pickup Convenience",
WhyChoosedescription: "The vehicle can be arranged from important Pune pickup locations such as Pune Airport, Viman Nagar, Kharadi, Hadapsar, Kothrud, Swargate, and other areas. This makes coordinated group pickup and drop arrangements easier for different types of travel."
},
{
WhyChooseheading: "Local and Outstation Flexibility",
WhyChoosedescription: "A 17-seater Urbania can be used for short local transfers as well as extended outstation journeys. This flexibility allows customers to plan one vehicle for sightseeing, corporate travel, family holidays, weddings, pilgrimage trips, and multi-city group travel."
},
{
WhyChooseheading: "Convenient Travel Planning with Ruturaj Enterprises",
WhyChoosedescription: "Ruturaj Enterprises can assist with planned group transportation based on the required pickup location, destination, travel schedule, and passenger capacity. This helps customers organize their journey around the specific requirements of their family, company, or travel group."
}
]
};














const faqData = [
{
question: "How can I hire a 17 Seater Urbania on rent in Pune from Ruturaj Enterprises?",
answer: "Customers can enquire about a 17 Seater Urbania by sharing the pickup location, travel date, destination, passenger count, trip duration, and planned itinerary. Ruturaj Enterprises can discuss the rental arrangement according to family tours, corporate travel, weddings, sightseeing programs, school trips, and outstation journeys."
},
{
question: "Who can rent a 17 Seater Urbania in Pune?",
answer: "A 17 Seater Urbania can be considered by families, corporate groups, tour operators, wedding parties, schools, colleges, social organizations, and other groups that need to travel together. The larger seating capacity is useful when a group wants to coordinate transportation through one dedicated vehicle."
},
{
question: "Can I hire a 17 Seater Urbania from Pune for an outstation trip?",
answer: "The 17 Seater Urbania can be used for group journeys from Pune to destinations such as Mumbai, Goa, Mahabaleshwar, Nashik, Shirdi, Kolhapur, Aurangabad, Lonavala, and other locations. One-way, round-trip, and multi-day requirements can be discussed according to the group's itinerary."
},
{
question: "Is a 17 Seater Urbania suitable for family tours from Pune?",
answer: "Large families can enquire about a 17 Seater Urbania for holidays, reunions, religious tours, sightseeing programs, and extended family trips. Travelling together in one vehicle can simplify coordination when the itinerary includes several destinations or multiple planned stops."
},
{
question: "Can a 17 Seater Urbania be booked for weddings and marriage functions in Pune?",
answer: "Wedding families can arrange a 17 Seater Urbania to transport relatives and guests between homes, hotels, wedding venues, reception halls, railway stations, and airports. It can be useful when several members of the wedding group need to follow the same schedule."
},
{
question: "Can companies hire a 17 Seater Urbania for corporate travel in Pune?",
answer: "Corporate organizations can enquire about a 17 Seater Urbania for employee outings, conferences, training programs, business events, team activities, client transportation, and industrial visits. The vehicle can support group movement when employees or guests need to travel between multiple business locations."
},
{
question: "Can I rent a 17 Seater Urbania for Pune sightseeing?",
answer: "Groups planning sightseeing around Pune and nearby destinations can hire a 17 Seater Urbania for a scheduled tour. The itinerary can include multiple attractions and return travel, allowing the complete group to follow the planned route together instead of arranging separate cars."
},
{
question: "Can a 17 Seater Urbania be used for school and college trips?",
answer: "Educational institutions and student groups can enquire about a 17 Seater Urbania for educational visits, picnics, excursions, industrial tours, and recreational programs. The travel plan, passenger count, pickup location, destination, and trip duration can be shared while planning the group transportation."
},
{
question: "Can a 17 Seater Urbania be hired for airport transfers in Pune?",
answer: "A 17 Seater Urbania can be useful for airport transfers involving large families, corporate groups, wedding parties, or tour groups. Customers can provide the airport pickup or drop location, flight timing, passenger count, luggage requirements, and desired reporting time when discussing the transportation arrangement."
},
{
question: "What details are needed to book a 17 Seater Urbania on rent in Pune?",
answer: "To enquire about a 17 Seater Urbania, customers can provide the pickup address, destination, travel date, number of passengers, rental duration, approximate route, and expected return timing. Details about multiple stops, accommodation locations, airport transfers, sightseeing, or special group requirements can also be shared with Ruturaj Enterprises."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Amit Patil",
feedback:
"We hired a 17 Seater Urbania from Ruturaj Enterprises for a family trip from Pune to Mahabaleshwar. There were several family members travelling together, so having one vehicle made the journey much easier to coordinate. The seating capacity worked well for our group and the overall travel arrangement was convenient.",
rating: 5
},
{
id: 2,
name: "Miss. Sneha Jadhav",
feedback:
"Our college group needed transportation for an educational visit with multiple stops. We selected a 17 Seater Urbania from Ruturaj Enterprises and shared the complete itinerary before the trip. Keeping everyone together in one vehicle made it simpler for our group to follow the planned schedule throughout the outing.",
rating: 5
}
];

































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Urbania on Rent in Pune",
  "image": "https://ruturajenterprises.com/assets/images/17-seater-urbania-on-rent-in-pune.webp",
  "description": "17 Seater Urbania on Rent in Pune from Ruturaj Enterprises is a spacious travel solution for large families, corporate groups, tour parties, wedding guests and other groups looking for comfortable transportation. 17 Seater Urbania Traveller Pune and 17 Seater Urbania Hire in Pune are suitable for local group travel, sightseeing, events, airport transfers and planned journeys with a professional driver. 17 Seater Urbania Booking Pune provides a convenient option for arranging group transportation in advance, while 17 Seater Urbania Van Rental Pune can be used for full-day trips, functions, corporate programs and longer travel requirements. The 17 Seater Luxury Urbania on Rent Pune option is suitable for passengers who prefer a premium and spacious travel environment for extended journeys. Urbania 17 Seater on Rent Near Me Pune can serve customers looking for a convenient pickup location in and around Pune. For intercity travel, 17 Seater Urbania for Outstation Pune is suitable for destinations across Maharashtra and other nearby states. Families planning vacations, pilgrimages or group tours can also choose 17 Seater Urbania for Family Trip Pune for comfortable travel with sufficient seating capacity and luggage space.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/17-seater-urbania-on-rent-in-pune"
  }
};






    return (
        <div>



<Helmet>
  <title>
    17 Seater Urbania on Rent in Pune | Luxury Group Traveller for Outstation & Family Trips | +91 9763381382
  </title>

  <meta
    name="description"
    content="17 Seater Urbania on Rent in Pune by Ruturaj Enterprises for family trips, group tours, corporate travel, outstation journeys, events, sightseeing and comfortable long-distance transportation."
  />

  <meta
    name="keywords"
    content="17 Seater Urbania on Rent in Pune, 17 Seater Urbania Traveller Pune, 17 Seater Urbania Hire in Pune, 17 Seater Urbania Booking Pune, 17 Seater Urbania Van Rental Pune, 17 Seater Luxury Urbania on Rent Pune, Urbania 17 Seater on Rent Near Me Pune, 17 Seater Urbania for Outstation Pune, 17 Seater Urbania for Family Trip Pune, 17 Seater Urbania Rental Pune, 17 Seater Urbania Traveller Hire Pune, 17 Seater Urbania Van on Rent Pune, 17 Seater Urbania with Driver Pune, 17 Seater Urbania Cab Pune, 17 Seater Urbania Taxi Pune, 17 Seater Urbania for Group Travel Pune, 17 Seater Urbania for Corporate Travel Pune, 17 Seater Urbania for Corporate Events Pune, 17 Seater Urbania for Wedding Pune, 17 Seater Urbania for Family Tour Pune, 17 Seater Urbania for Outstation Trips Pune, 17 Seater Urbania for Maharashtra Tour Pune, 17 Seater Urbania Airport Transfer Pune, 17 Seater Urbania Sightseeing Pune, 17 Seater Luxury Traveller Pune, Pune 17 Seater Urbania rental with driver, Pune 17 Seater Urbania outstation hire, Pune 17 Seater Urbania family tour, Pune 17 Seater Urbania group transportation, Pune 17 Seater Urbania van hire, Pune 17 Seater Urbania long distance rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/104.png' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onesevanseaterurbania;